import React from 'react';
const calcGrowth = (from, to) => (to - from) / from || 0;
const GrowthDisplay = (props) => (React.createElement("span", { className: calcGrowth(props.prev, props.curr) >= 0 ? 'positive' : 'negative' },
    calcGrowth(props.prev, props.curr) > 0 && '+',
    (calcGrowth(props.prev, props.curr) * 100).toFixed(2),
    "%"));
export default GrowthDisplay;
//# sourceMappingURL=GrowthDisplay.js.map